import React, { useState } from 'react'
import { FaDesktop, FaMobileAlt, FaAndroid, FaShoppingCart, FaBoxes, FaCheckCircle, FaUserTie, FaGlobe } from "react-icons/fa";
import { FaCartPlus, FaClipboardList, FaUserCheck } from "react-icons/fa6";

import seller_orders_view from '../../../assets/Docs/buyer_orders.png'
import view_suplplier from '../../../assets/Docs/Show_All_Supllier.png'
import Supllier_products from '../../../assets/Docs/Buyers_Cart.png'
import Select_productss from '../../../assets/Docs/Carts_details.png'
import buyer_order_app from '../../../assets/AppImages/Buyer_orders.png'
import Select_supllier from '../../../assets/AppImages/Select_supllier.png'
import cart_select from '../../../assets/AppImages/cart_select.png'
import cart_details from '../../../assets/AppImages/cart_details.png'
import { TagComponent } from '../Tabs';


const PlaceOrder = () => {

    const [activeTab2, setActiveTab2] = useState('web');
    const [activeTab1, setActiveTab1] = useState('web');
    const [activeTab3, setActiveTab3] = useState('web');
    const [activeTab4, setActiveTab4] = useState('web');

    const tabs = [
        { id: 'web', label: 'Web App', icon: <FaDesktop /> },
        { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
    ];

    const renderTabs = (activeState, setActiveState) => (
        <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => setActiveState(tab.id)}
                    className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
                        ? "bg-[#1a9588] text-white shadow"
                        : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
                        } `}

                >
                    {tab.icon}
                    {tab.label}
                </button>
            ))}
        </div>
    );

    const steps = [
        { text: "Go to 'Orders' Section", icon: <FaClipboardList className="text-white w-4 h-4" /> },
        { text: "Add New Order", icon: <FaShoppingCart className="text-white w-4 h-4" /> },
        { text: "Buyers select their 'Supplier' & Suppliers (Sellers) select their 'Buyer'", icon: <FaUserCheck className="text-white w-4 h-4" /> },
        { text: "Add Items to your Order Cart", icon: <FaBoxes className="text-white w-4 h-4" /> },
        { text: "Finalise Cart & Place Order", icon: <FaCheckCircle className="text-white w-4 h-4" /> },
    ];


    return (
        <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

            <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
                <FaCartPlus className="text-4xl text-theme-logo-color mr-3" />
                <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Placing Orders</h1>
            </div>


            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
                <div className="flex flex-wrap gap-3">
                    <TagComponent icon={<FaUserTie />} label="Seller" color="pink" />
                    <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
                </div>
                <div className="flex flex-wrap gap-3">
                    <TagComponent icon={<FaGlobe />} label="Web" color="green" />
                    <TagComponent icon={<FaAndroid />} label="Android" color="green" />
                </div>
            </div>



            {/* Intro Text */}
            <div className="bg-gray-50 p-3 rounded-2xl ">
                <p className="text-gray-700 text-start text-base leading-relaxed ">
                    The steps for 'Placing Orders' are the same from both web & mobile apps.
                </p>
            </div>

            <div className=" p-6 my-5 bg-white rounded-3xl shadow-lg border border-gray-200">
                <ul className="space-y-5">
                    {steps.map((step, index) => (
                        <li key={index} className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center mt-1">
                                {step.icon}
                            </div>
                            <p className="text-gray-700 text-base leading-relaxed">{step.text}</p>
                        </li>
                    ))}
                </ul>

                <p className="mt-6 text-gray-500 text-sm text-start">
                    "When you open the 'Orders' section, a list of new orders is displayed by default. To see other orders, simply adjust the settings above the list."
                </p>

            </div>

            {/* Steps Section */}

            <div className="">
                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">
                    {activeTab1 === "web" ? (
                        <img
                            src={seller_orders_view}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    ) : (
                        <img
                            src={buyer_order_app}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    )}
                    <p className="mt-6 text-gray-500 text-sm ">
                        Tap 'Add New Order' to create a new order. Buyers will see their list of 'Suppliers,' while Suppliers (Sellers) will see their list of 'Buyers.' Choose the appropriate contact to place a new order for that supplier or buyer.
                    </p>
                </div>
            </div>

            <div className="my-5">

                {renderTabs(activeTab2, setActiveTab2)}
                <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">

                    <p className="mt-6 text-gray-500 text-sm ">
                        On the web app, the order cart and product list appear on a single screen, while on the mobile app, you can switch between these views using the tabs at the bottom
                    </p>

                    {/* <img src={view_suplplier} alt={`view`} className="rounded-xl max-w-full h-auto object-contain" /> */}

                    {activeTab2 === "web" ? (
                        <img
                            src={view_suplplier}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    ) : (
                        <img
                            src={Select_supllier}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    )}
                </div>

                <div className="my-4 mx-auto p-6 space-y-6 text-start">
                    {/* Instruction Paragraph */}
                    <p className="text-gray-700 text-base leading-relaxed">
                        "To add products to your cart, choose the item and enter the desired quantity or use the '+' and '-' buttons. Once ready, click or tap 'Add to Order.' The item will be added to your cart, which is saved in real-time. Your cart will retain its contents even if you close or log out of the app. If the product is already in your cart, adding it again will update the item and increase the quantity accordingly.
                    </p>

                    {/* Info Box */}
                    <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300">
                        The item is added to the selected order cart. There are 3 Order Carts in total.
                    </div>

                    <p className="text-gray-700 text-base leading-relaxed">
                        After adding an item to the cart, you can adjust its quantity, delete it from the cart, or transfer it to one of the other two order carts.
                    </p>

                    <p className="text-gray-700 text-base leading-relaxed">
                        Once you’ve finished adding items to the cart, you can finalise it. This allows you to review your order before submission. In step 2 of the finalisation process, you can set the 'Order Priority,' 'Shipping Address,' and include a 'Message.' After that, you can 'Place Order.
                    </p>

                    {/* Warning Box */}
                    <div className="bg-red-100 text-red-700 p-4 rounded-lg border border-red-300">
                        An order cart is locked while a user is finalising it. Other users cannot modify or interact with the cart until the finalisation is either completed or cancelled. The cart remains locked for 15 minutes, after which other users can access it.
                    </div>
                </div>
            </div>




            <div>
                {renderTabs(activeTab3, setActiveTab3)}
                <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">


                    {activeTab3 === "web" ? (
                        <img
                            src={Supllier_products}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    ) : (
                        <img
                            src={cart_select}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    )}
                </div>
            </div>

            <div className="my-5">
                {renderTabs(activeTab4, setActiveTab4)}
                <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">


                    {activeTab4 === "web" ? (
                        <img
                            src={Select_productss}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    ) : (
                        <img
                            src={cart_details}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    )}
                </div>
            </div>


        </div>
    )
}

export default PlaceOrder